const getSearchType = (type: SearchTypes) => {
    return searchTypes.find((s) => s.id === type);
};

export const getSpecificSearchTypes = (types: SearchTypes[]) => {
    return types.map(getSearchType);
};

type SearchTypes = (typeof searchTypes)[number]["id"];

export interface SearchEngine {
    id: string;
    text: string;
    count?: number;
}

const searchTypes: SearchEngine[] = [
    {
        id: "google",
        text: "Google",
        count: 0,
    },
    {
        id: "duckduckgo",
        text: "Duckduckgo",
        count: 0,
    },
    {
        id: "yahoo",
        text: "Yahoo",
        count: 0,
    },
    {
        id: "syndicated",
        text: "Syndicated",
        count: 0,
    },
    {
        id: "yandex",
        text: "Yandex",
        count: 0,
    },
    {
        id: "bing",
        text: "Bing",
        count: 0,
    },
    {
        id: "qwant",
        text: "Qwant",
        count: 0,
    },
    {
        id: "lo",
        text: "Lo",
        count: 0,
    },
    {
        id: "ask",
        text: "Ask",
        count: 0,
    },
    {
        id: "naver",
        text: "Naver",
        count: 0,
    },
    {
        id: "rambler",
        text: "Rambler",
        count: 0,
    },
    {
        id: "cc",
        text: "Cc",
    },
    {
        id: "aol",
        text: "Aol",
    },
    {
        id: "baidu",
        text: "Baidu",
    },
    {
        id: "izo",
        text: "Izo",
    },
    {
        id: "zapmeta",
        text: "Zapmeta",
    },
] as const;

export default searchTypes;
